import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProtesisService {

  constructor(
    private http: HttpClient
  ) { }

  sendForm(enviarForm: FormData): Observable<any>{
    return this.http.post(`${environment.urlApi}protesis/sendProstheticsRequest?sid=` + environment.sessionId, enviarForm);

    
  }   
}
